// extracted by mini-css-extract-plugin
export default {"button-container":"l8j8e","input":"Z0IVk","link":"qJ7go"};